import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../../../views/types';
import type { SectionsPropsType } from '../../../../sections/types';
import { renderAdvisorMessage } from '../../../../views/AdvisorMessage';
import { renderUserMessage } from '../../../../views/UserMessage';
import { renderSimpleButtonGroup } from '../../../../views/SimpleButtonGroup';
import { renderSingleImage } from '../../../../views/SingleImage';
import { buildAnswers, buildUserAnswerMessage } from '../../../../sections/utils';

import WallChalkingExampleJpgPath from 'Images/me/pages/guest/proposals/new/wall_chalking/example.jpg'
import WallChalkingExampleWebPPath from 'Images/me/pages/guest/proposals/new/wall_chalking/example.webp'

const SECTION_KEY_NAME = 'wallChalking';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'chalking';

export const wallChalkingSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: '写真のように白くなります', textContents: (<>写真のように<br />白くなる</>) },
    { value: '少し白くなります', textContents: (<>少し<br />白くなる</>) },
    { value: 'まったくない', textContents: (<>まったく<br />ない</>) },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '外壁にチョーキングはあるか',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderSingleImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    imagePaths: {
      imagePath: WallChalkingExampleJpgPath,
      webp: WallChalkingExampleWebPPath,
    },
    altText: '外壁のチョーキング',
    viewWidth: {
      pc: 350,
      mobile: 320,
    },
    imageRatio: { width: 350, height: 222 },
    withWebp: true,
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        外壁を触ったときに、手に白い粉がつくことをチョーキングといいます。<br />
        古いガードレールを触ったときのような粉です。
      </>
    ),
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        チョーキングはありますか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.value),
  });

  // 回答内容を返却する
  return answer;
};
